import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext'; // Import AuthProvider
import { useMediaQuery } from 'react-responsive'; // Import useMediaQuery
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Admin from './pages/Admin/Admin';
import Auth from './pages/AuthPage/AuthPage';
import Programs from './pages/Programs/Programs';
import Header from './components/Header/Header';
import MobileHeader from './components/Header/MobileHeader'; 
import Footer from './components/Footer/Footer';
import Masters from './pages/Masters/Masters';
import MasterDetailsPage from './pages/MasterDetailsPage/MasterDetailsPage'
import CalendarPage from './pages/CalendarPage/CalendarPage';
import TeensPage from './pages/TeensPage/TeensPage';
import MembershipPage from './pages/MembershipPage/MembershipPage'; 
import ProgramDetails from './pages/ProgramDetails/ProgramDetails';
import EventDetails from './pages/EventDetails/EventDetails';
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import './App.css'; // Import the CSS file
import BookClubPage from './pages/BookClubPage/BookClubPage';
import EventsPage from './pages/EventsPage/EventsPage';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import CookiesPolicy from './pages/CookiesPolicy/CookiesPolicy';

// Simulated language selection (Replace with actual language state from your context/store)
const getCurrentLanguage = () => localStorage.getItem('language') || 'en';

const App: React.FC = () => {
  const location = useLocation();
  const isAuthPage = location.pathname === '/login';
  const isMobile = useMediaQuery({ maxWidth: 768 });

  // Update font based on the selected language
  const [language, setLanguage] = useState(getCurrentLanguage());

  useEffect(() => {
    console.log("Setting font for language:", language);
  
    // Reset font to ensure update applies
    document.documentElement.style.removeProperty('--title-font');
  
    // Wait for a tiny delay to allow reset, then apply the correct font
    setTimeout(() => {
      document.documentElement.style.setProperty(
        '--title-font',
        language === 'ru' ? "'Cormorant Garamond', serif" : "'Gloock', serif"
      );
    }, 50);
  }, [language]);
  
  // Example function to change language (call this on language switch)
  const changeLanguage = (lang: string) => {
    localStorage.setItem('language', lang);
    setLanguage(lang); // Trigger state update
  };
  

  return (
    <>
      {!isAuthPage && (isMobile ? <MobileHeader /> : <Header />)}

      <main>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<Auth />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/program/:programId" element={<ProgramDetails />} />
          <Route path="/program/:programId/event/:eventId" element={<EventDetails />} />
          <Route path="/masters" element={<Masters />} />
          <Route path="/masters/:masterId" element={<MasterDetailsPage />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/Admin" element={<Admin />} />
          <Route path="/teens" element={<TeensPage />} />
          <Route path="/book-club" element={<BookClubPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
         <Route path="/privacy-policy" element={<PrivacyPolicy />} />
         <Route path="/cookies-policy" element={<CookiesPolicy />} />

        </Routes>
      </main>

      {!isAuthPage && <Footer />}
    </>
  );
};

// Wrap App component in Router and AuthProvider
const WrappedApp: React.FC = () => (
  <AuthProvider>
    <Router>
      <App />
    </Router>
  </AuthProvider>
);

export default WrappedApp;
